<template>
  <IQOS required :readonly="false" :title="$t('marketplace.flavors_title')">
    <div
      :class="{
        'flavor-row': true,
        'mt-16': true
      }"
      v-for="(flavor) in all_flavors"
      :key="flavor._id"
    >
      <BaseCheckbox
        :value="selected_flavors.includes(flavor._id)"
        @input="onToggle(flavor._id)"
      >
        <!-- <img :src="flavor.image"> -->
        {{ getFlavorDisplayName(flavor) }}
      </BaseCheckbox>
    </div>

    <p class="iqos-comment mt-16 c-grey">
      {{ $t("marketplace.flavors_desc") }}
    </p>

    <p :class="{
      'iqos-comment mt-16': true,
      'orange-4-color': selected_flavors.length == 0
    }">
      {{ $t("marketplace.flavors_one") }}
    </p>

    <p class="iqos-comment mt-16">
      {{ $t("marketplace.flavors_not_found") }}
      {{ $t("marketplace.flavors_support") }}
    </p>

    <!-- <IQOSActions
      :editing="editing"
      @edit="showEditUI"
      @cancel="hideEditUI"
      @accept="saveChanges"
    /> -->
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import RoundCheckbox from "@/components/RoundCheckbox.vue";

import IQOSActions from "@/components/IQOSActions.vue";

import MarketplaceAPI from "@/api/marketplace";

export default {
  components: {
    IQOS,
    IQOSActions,
    RoundCheckbox,
  },
  data() {
    return {
      all_flavors: [],

      selected_flavors: [],

      editing: true,
    };
  },
  methods: {
    fetchAllFlavors() {
      MarketplaceAPI.getFlavors()
        .then((data) => {
          this.all_flavors = data.flavors;
        })
        .catch((error) => {});
    },
    onToggle(flavor_id) {
      if (!this.editing) return;

      const index = this.selected_flavors.findIndex((i) => i == flavor_id);
      if (index !== -1) {
        this.selected_flavors.splice(index, 1);
      } else {
        if (this.selected_flavors.length < 5) this.selected_flavors.push(flavor_id);
      }

      this.saveChanges();
    },
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    saveChanges() {
      if (this.selected_chain) {
        this.$store.commit("setChainData", {
          key: "food_flavors",
          value: this.selected_flavors,
        });
        this.$store.dispatch("saveChain");
      } else {
        this.$store.commit("setFoodFlavors", this.selected_flavors);
        this.$store.dispatch("saveCafe");
      }

      this.$store.dispatch("auditlog/write", {
        type: "change_food_flavors",
        payload: {
          ids: this.selected_flavors,
          count: this.selected_flavors.length
        },
      });

      // this.editing = false;
    },
    reset() {
      if (this.selected_chain) {
        this.selected_flavors = this.selected_chain.food_flavors.slice();
      } else {
        this.selected_flavors = this.cafe.food_flavors.slice();
      }
    },
    getFlavorDisplayName(flavor) {
      if (!flavor.i18n) return flavor.name;

      //forgive me
      //dashboard uses 'ua' as language
      //but everywhere else it's 'uk'
      //TODO: fix at sometime
      const target_lang = this.$i18n.locale == 'ua' ? 'uk' : this.$i18n.locale;

      return flavor.i18n[target_lang] || flavor.name;
    }
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    selected_chain() {
      return this.$store.state.selected_chain;
    },
  },
  mounted() {
    this.reset();
    this.fetchAllFlavors();
  },
};
</script>

<style scoped>
.flavor-row img {
  width: 3vh;
  height: auto;
  display: inline-block;
  border-radius: 0.5vh;
}
</style>
